// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.team-search {
  max-width: 960px;
  margin: 0 auto;
  padding: 4px 4px 32px;
  color: var(--vb-text);
  box-sizing: border-box;
}

.team-search-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}

.team-search-toolbar-left h1,
.team-search-toolbar-left .text-back {
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--vb-text);
}

.text-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.ghost-link {
  background: none;
  border: none;
  color: var(--vb-text-muted);
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
  padding: 4px 0;
}

.team-search-tabs {
  display: flex;
  gap: 0;
  margin: 0 0 14px;
  border-bottom: 1px solid var(--vb-border);
}

.team-search-tabs button {
  flex: 1 1;
  min-height: 40px;
  border: none;
  background: transparent;
  color: var(--vb-text-muted);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
}

.team-search-tabs button.active {
  color: var(--vb-text);
  border-bottom-color: var(--vb-primary);
}

.team-search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  padding: 0 12px;
  min-height: 44px;
}

.team-search-bar.compact {
  min-height: 40px;
}

.team-search-bar svg {
  color: var(--vb-text-muted);
  flex-shrink: 0;
}

.team-search-bar input {
  flex: 1 1;
  border: none;
  background: transparent;
  color: var(--vb-text);
  font-size: 15px;
  min-height: 40px;
  outline: none;
}

.hint {
  margin: 8px 0 12px;
  font-size: 12px;
  color: var(--vb-text-muted);
  font-weight: 600;
}

.team-search-error {
  background: var(--vb-danger-soft);
  color: var(--vb-danger);
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 650;
  margin-bottom: 10px;
}

.team-search-empty {
  text-align: center;
  padding: 36px 16px;
  color: var(--vb-text-muted);
  font-size: 14px;
}

.team-search-empty svg {
  margin-bottom: 8px;
  opacity: 0.4;
}

.team-result-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.team-result {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  align-items: stretch;
}

.team-result-main,
.compare-card,
.game-row {
  width: 100%;
  text-align: left;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  color: inherit;
}

.team-result-main {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas:
    "name record"
    "meta meta"
    "similar similar";
  gap: 2px 10px;
  padding: 10px 12px;
  cursor: pointer;
}

.team-result-main:hover,
.game-row:hover {
  background: var(--vb-surface-hover);
}

.team-result-name {
  grid-area: name;
  font-size: 14px;
  font-weight: 750;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.team-result-record {
  grid-area: record;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  font-size: 13px;
}

.team-result-meta,
.similar-note,
.compare-meta {
  font-size: 11px;
  font-weight: 600;
  color: var(--vb-text-muted);
}

.team-result-meta { grid-area: meta; }
.similar-note { grid-area: similar; margin-top: 2px; }

.compare-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-height: 40px;
  padding: 0 10px;
  border: 1px solid var(--vb-border);
  border-radius: 12px;
  background: var(--vb-surface);
  color: var(--vb-text);
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
}

.team-games-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}

.team-games-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 800;
}

.team-games-header p {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--vb-text-muted);
  font-weight: 650;
}

.team-games-actions {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.similar-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 650;
  margin: 0 0 10px;
}

.alias-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  margin-bottom: 12px;
  font-size: 12px;
  color: var(--vb-text-muted);
  font-weight: 650;
}

.alias-chip {
  border: 1px solid var(--vb-border);
  background: var(--vb-surface-2);
  color: var(--vb-text);
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 650;
  cursor: pointer;
}

.game-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.game-row {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 10px;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  border-left-width: 4px;
}

.game-row.win { border-left-color: var(--vb-success); }
.game-row.loss { border-left-color: var(--vb-danger); }
.game-row.tie { border-left-color: var(--vb-warning); }

.game-date {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--vb-text-muted);
  font-weight: 650;
  min-width: 92px;
}

.game-matchup {
  font-size: 13px;
  min-width: 0;
}

.game-matchup em {
  font-style: normal;
  color: var(--vb-text-muted);
  font-size: 11px;
  margin-left: 4px;
}

.game-score {
  font-family: var(--vb-font-score);
  font-size: 20px;
  font-weight: 800;
}

.game-score.win { color: var(--vb-success); }
.game-score.loss { color: var(--vb-danger); }
.game-score.tie { color: var(--vb-warning); }

.compare-pickers {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.team-picker label {
  display: block;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--vb-text-muted);
  margin-bottom: 6px;
}

.selected-name {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 650;
  color: var(--vb-text-muted);
}

.picker-suggestions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 6px;
}

.picker-suggestions button {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  text-align: left;
  background: var(--vb-surface);
  border: 1px solid var(--vb-border);
  border-radius: 10px;
  padding: 8px 10px;
  cursor: pointer;
  color: inherit;
  font-size: 13px;
  font-weight: 650;
}

.compare-cards {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin: 12px 0;
}

.compare-card {
  padding: 12px;
}

.compare-card h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 800;
}

.compare-record {
  margin: 6px 0 2px;
  font-family: var(--vb-font-score);
  font-size: 28px;
  font-weight: 800;
}

.compare-meta { margin: 0; }

.h2h h3 {
  margin: 0 0 4px;
  font-size: 13px;
  font-weight: 800;
  color: var(--vb-text-muted);
}

.h2h-score {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 750;
}

@media (min-width: 640px) {
  .team-search { padding: 8px 8px 40px; }
  .compare-pickers { grid-template-columns: 1fr 1fr; }
}
`, "",{"version":3,"sources":["webpack://./src/components/TeamSearch.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;EACR,oBAAoB;AACtB;;AAEA;;;EAGE,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C;;;qBAGmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,oBAAoB,eAAe,EAAE;AACrC,gBAAgB,kBAAkB,EAAE,eAAe,EAAE;;AAErD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA,gBAAgB,oCAAoC,EAAE;AACtD,iBAAiB,mCAAmC,EAAE;AACtD,gBAAgB,oCAAoC,EAAE;;AAEtD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA,kBAAkB,wBAAwB,EAAE;AAC5C,mBAAmB,uBAAuB,EAAE;AAC5C,kBAAkB,wBAAwB,EAAE;;AAE5C;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;;AAEA,gBAAgB,SAAS,EAAE;;AAE3B;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe,qBAAqB,EAAE;EACtC,mBAAmB,8BAA8B,EAAE;AACrD","sourcesContent":[".team-search {\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 4px 4px 32px;\n  color: var(--vb-text);\n  box-sizing: border-box;\n}\n\n.team-search-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 8px;\n}\n\n.team-search-toolbar-left h1,\n.team-search-toolbar-left .text-back {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: var(--vb-text);\n}\n\n.text-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.ghost-link {\n  background: none;\n  border: none;\n  color: var(--vb-text-muted);\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n  padding: 4px 0;\n}\n\n.team-search-tabs {\n  display: flex;\n  gap: 0;\n  margin: 0 0 14px;\n  border-bottom: 1px solid var(--vb-border);\n}\n\n.team-search-tabs button {\n  flex: 1;\n  min-height: 40px;\n  border: none;\n  background: transparent;\n  color: var(--vb-text-muted);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n}\n\n.team-search-tabs button.active {\n  color: var(--vb-text);\n  border-bottom-color: var(--vb-primary);\n}\n\n.team-search-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  padding: 0 12px;\n  min-height: 44px;\n}\n\n.team-search-bar.compact {\n  min-height: 40px;\n}\n\n.team-search-bar svg {\n  color: var(--vb-text-muted);\n  flex-shrink: 0;\n}\n\n.team-search-bar input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  color: var(--vb-text);\n  font-size: 15px;\n  min-height: 40px;\n  outline: none;\n}\n\n.hint {\n  margin: 8px 0 12px;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n  font-weight: 600;\n}\n\n.team-search-error {\n  background: var(--vb-danger-soft);\n  color: var(--vb-danger);\n  padding: 10px 12px;\n  border-radius: 10px;\n  font-size: 13px;\n  font-weight: 650;\n  margin-bottom: 10px;\n}\n\n.team-search-empty {\n  text-align: center;\n  padding: 36px 16px;\n  color: var(--vb-text-muted);\n  font-size: 14px;\n}\n\n.team-search-empty svg {\n  margin-bottom: 8px;\n  opacity: 0.4;\n}\n\n.team-result-list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.team-result {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 8px;\n  align-items: stretch;\n}\n\n.team-result-main,\n.compare-card,\n.game-row {\n  width: 100%;\n  text-align: left;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  color: inherit;\n}\n\n.team-result-main {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  grid-template-areas:\n    \"name record\"\n    \"meta meta\"\n    \"similar similar\";\n  gap: 2px 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n}\n\n.team-result-main:hover,\n.game-row:hover {\n  background: var(--vb-surface-hover);\n}\n\n.team-result-name {\n  grid-area: name;\n  font-size: 14px;\n  font-weight: 750;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.team-result-record {\n  grid-area: record;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  font-size: 13px;\n}\n\n.team-result-meta,\n.similar-note,\n.compare-meta {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--vb-text-muted);\n}\n\n.team-result-meta { grid-area: meta; }\n.similar-note { grid-area: similar; margin-top: 2px; }\n\n.compare-chip {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  min-height: 40px;\n  padding: 0 10px;\n  border: 1px solid var(--vb-border);\n  border-radius: 12px;\n  background: var(--vb-surface);\n  color: var(--vb-text);\n  font-size: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.team-games-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.team-games-header h2 {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.team-games-header p {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n  font-weight: 650;\n}\n\n.team-games-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 6px;\n}\n\n.similar-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 650;\n  margin: 0 0 10px;\n}\n\n.alias-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  margin-bottom: 12px;\n  font-size: 12px;\n  color: var(--vb-text-muted);\n  font-weight: 650;\n}\n\n.alias-chip {\n  border: 1px solid var(--vb-border);\n  background: var(--vb-surface-2);\n  color: var(--vb-text);\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 650;\n  cursor: pointer;\n}\n\n.game-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.game-row {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 10px;\n  align-items: center;\n  padding: 10px 12px;\n  cursor: pointer;\n  border-left-width: 4px;\n}\n\n.game-row.win { border-left-color: var(--vb-success); }\n.game-row.loss { border-left-color: var(--vb-danger); }\n.game-row.tie { border-left-color: var(--vb-warning); }\n\n.game-date {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  color: var(--vb-text-muted);\n  font-weight: 650;\n  min-width: 92px;\n}\n\n.game-matchup {\n  font-size: 13px;\n  min-width: 0;\n}\n\n.game-matchup em {\n  font-style: normal;\n  color: var(--vb-text-muted);\n  font-size: 11px;\n  margin-left: 4px;\n}\n\n.game-score {\n  font-family: var(--vb-font-score);\n  font-size: 20px;\n  font-weight: 800;\n}\n\n.game-score.win { color: var(--vb-success); }\n.game-score.loss { color: var(--vb-danger); }\n.game-score.tie { color: var(--vb-warning); }\n\n.compare-pickers {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.team-picker label {\n  display: block;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--vb-text-muted);\n  margin-bottom: 6px;\n}\n\n.selected-name {\n  margin-top: 4px;\n  font-size: 11px;\n  font-weight: 650;\n  color: var(--vb-text-muted);\n}\n\n.picker-suggestions {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.picker-suggestions button {\n  display: flex;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  text-align: left;\n  background: var(--vb-surface);\n  border: 1px solid var(--vb-border);\n  border-radius: 10px;\n  padding: 8px 10px;\n  cursor: pointer;\n  color: inherit;\n  font-size: 13px;\n  font-weight: 650;\n}\n\n.compare-cards {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n  margin: 12px 0;\n}\n\n.compare-card {\n  padding: 12px;\n}\n\n.compare-card h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.compare-record {\n  margin: 6px 0 2px;\n  font-family: var(--vb-font-score);\n  font-size: 28px;\n  font-weight: 800;\n}\n\n.compare-meta { margin: 0; }\n\n.h2h h3 {\n  margin: 0 0 4px;\n  font-size: 13px;\n  font-weight: 800;\n  color: var(--vb-text-muted);\n}\n\n.h2h-score {\n  margin: 0 0 10px;\n  font-size: 15px;\n  font-weight: 750;\n}\n\n@media (min-width: 640px) {\n  .team-search { padding: 8px 8px 40px; }\n  .compare-pickers { grid-template-columns: 1fr 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
